import Service from "../Service";
import AccountService from "./AccountService";
import DateHelper from "../../components/DateHelper";
import moment from 'moment';
import ClinicService from "./ClinicService";

const account = new AccountService();

export default class AppointmentService extends Service{
	getById(id, cb){
		return this.request('Appointments/' + id, {}, cb);
	}

	getByDates = (start, end, clinicId, opts = {}) => {
		return this.search( Object.assign({StartDate: start, EndDate: end, ClinicId: clinicId}, opts) );
	}

	getByUserId = (userId, start, end, opts = {}) => {
		return this.search( Object.assign({StartDate:start, EndDate:end, PatientId:userId}, opts) );
	}

	getByDrId = (id, start, end, opts = {}) => {
		return this.search( Object.assign({StartDate:start, EndDate:end, userId:id}, opts) );
	}

	search = (options) => {
		let opts = {
			ClinicId: options.ClinicId || account.clinicId,
			StartDate: DateHelper.DateToServerString(options.StartDate || moment(0)),
			EndDate: DateHelper.DateToServerString(options.EndDate || moment().add(1, 'day'))
		}

		for (let p in options){
			let v = options[p];
			switch(p.toLowerCase()){
			case 'startdate':
			case 'enddate':

				break;
			default:
				if(v != null)opts[p] = options[p];
				break;
			}
		}

		//console.log("apointment Search:", opts);

		return this.request('AppointmentSearch', {
			post: opts
		}).then((apts) => {
			return (apts || []).sort((a, b) => {
				return moment(a.start).diff(b.start);
			});
		})

	}

	//Properties allowed in the creat appointment call
	createAppVars = [
		"appointmentId",
		"clientId",
		"created",
		"modified",
		"start",
		"end",
		"userId",
		"appointmentTypeId",
		"comment",
		"status",
		"clinicId",
		"recurType",
		"comment",
		"reminders",
		"numRecur",
		"date",
		"externalAppointmentId",
		"clientHasRx",
		"recurrenceDuration"
	]
	createApp(d){


		//If appointmendId is included then update that appointment insteadof creating one.

		let props = {};

		for(let i=0; i < this.createAppVars.length; i++){
			let p = this.createAppVars[i];
			if(d[p] !== null){
				props[p] = d[p];
			}
		}

		props.comment = props.comment || '';

		let req = {};
		let method = (props.appointmentId)? 'put': 'post';
		req[method] = props;

		return this.request('Appointments' + ((props.appointmentId) ? '/' + props.appointmentId: ''), req);
	}

	/**
	 *
	 * @param id
	 * @param {('single' | 'all' | 'other', null)} deleteType - If the appointments a recurring type
	 * @returns {Promise | Promise<unknown>}
	 */
	delete(id, deleteType = null){
		if(deleteType) {
			return this.request('Appointments/recurring', {
				delete: {
					"AppointmentId": id,
					"DeleteType": deleteType
				}
			})
		}
		return this.request('Appointments/' + id, {
			delete:{}
		})
	}

	/**
	 *
	 * @param id
	 * @param {('single'|'all'|'other')} type
	 */
	deleteRecurring(id, type) {
		return this.request('/Appointments/recurring', {
			delete: {
				"AppointmentId": id,
				"DeleteType": type
			}
		})
	}

	updateStatus(appid, status, secret){
		return this.request('appointments/status/' + appid, {
			put:{
				appointmentId: appid,
				newstatus: status,
				secret: secret
			}
		})
	}

	static IsValidAppTime(app){
		let doctor = ClinicService.GetDrById(app.userId, app.clinicId);
		let hours = doctor.settings.schedule.cache.getDateHours(app.start);
		console.log('*&* Hours:', hours);
		if(!hours) return false;

		let dStart = moment(hours[0], 'h:mm a');
		let dEnd = moment(hours[1], 'h:mm a');

		let appStart = moment( moment(app.start).format('h:mm a'), 'h:mm a' );
		let appEnd = moment( moment(app.end).format('h:mm a'), 'h:mm a' );

		return appStart.isSameOrAfter(dStart) && appEnd.isSameOrBefore(dEnd);
	}

}



// WEBPACK FOOTER //
// ./src/api/services/AppointmentService.js